import styled from "styled-components";
import { useState } from "react";
import { useNavigate } from "react-router-dom";

export default function Header() {
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <Container>
      <Logo src="/img/logo.png" alt="Logo SPC Escola" onClick={() => navigate("/")} />

      <MenuToggle onClick={() => setMenuOpen(!menuOpen)}>
        <div className={menuOpen ? "bar open" : "bar"}></div>
        <div className={menuOpen ? "bar open" : "bar"}></div>
        <div className={menuOpen ? "bar open" : "bar"}></div>
      </MenuToggle>

      <Nav open={menuOpen}>
        <p onClick={() => {navigate("/"); setMenuOpen(false);}}>Home</p>
        <p onClick={() => {navigate("/sobre"); setMenuOpen(false);}}>Sobre nós</p>
        <p onClick={() => {navigate("/contato"); setMenuOpen(false);}}>Contato</p>
      </Nav>
    </Container>
  );
}

const Container = styled.header`
  width: 100vw;
  height: 100px;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 10;
  background-color: #ffffff;
  display: flex;
  justify-content: space-around;
  align-items: center;
  padding: 10px 0;
  box-sizing: border-box;
  box-shadow: 0 2px 10px rgba(0,0,0,0.05);

  @media (max-width: 768px) {
    padding: 10px 0;
    box-sizing: border-box;
  }
`;

const Logo = styled.img`
  height: 80px;
  cursor: pointer;

  @media (max-width: 768px) {
    height: 60px;
  }
`;

const Nav = styled.nav`
  display: flex;
  align-items: center;
  gap: 30px;

  p {
    position: relative;
    padding-bottom: 4px;
    cursor: pointer;
    color: #333;
    font-family: 'Poppins', sans-serif;
    font-weight: 600;
    transition: color 0.3s ease;

    &::after {
      content: "";
      position: absolute;
      left: 0;
      bottom: 0;
      width: 100%;
      height: 2px;
      background: #264b91;
      transform: scaleX(0);
      transform-origin: left;
      transition: transform 0.3s ease;
    }

    &:hover {
      color: #264b91;
    }

    &:hover::after {
      transform: scaleX(1);
    }
  }

  @media (max-width: 768px) {
    position: absolute;
    top: 100%;
    right: 0;
    flex-direction: column;
    background: #ffffff;
    width: 100%;
    max-height: ${({ open }) => (open ? "300px" : "0")};
    overflow: hidden;
    transition: max-height 0.4s ease;
    box-shadow: ${({ open }) => (open ? "0 4px 20px rgba(0,0,0,0.1)" : "none")};
    gap: 15px;
    padding: ${({ open }) => (open ? "20px 0" : "0")};
    text-align: center;

    p {
      font-size: 18px;
    }
  }
`;

const MenuToggle = styled.div`
  display: none;
  flex-direction: column;
  justify-content: space-between;
  width: 26px;
  height: 18px;
  cursor: pointer;

  .bar {
    height: 3px;
    width: 100%;
    background-color: #333;
    border-radius: 5px;
    transition: all 0.3s ease;
  }

  .open:nth-child(1) {
    transform: rotate(45deg) translate(5px, 5px);
  }
  .open:nth-child(2) {
    opacity: 0;
  }
  .open:nth-child(3) {
    transform: rotate(-45deg) translate(6px, -6px);
  }

  @media (max-width: 768px) {
    display: flex;
  }
`;
